"use strict";
/*
 * This file was automatically generated by `./packages/ethereum/console.log/scripts/generate.ts`; do not edit. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.signatureMap = void 0;
const handlers_1 = require("./handlers");
exports.signatureMap = new Map([
    // log()
    [1368866505, []],
    // log(address)
    [741264322, [handlers_1.address]],
    // log(bool)
    [843419373, [handlers_1.bool]],
    // log(string)
    [1093685164, [handlers_1.string]],
    // log(uint256)
    [4163653873, [handlers_1.uint256]],
    // log(uint)
    [4122065833, [handlers_1.uint256]],
    // log(bytes)
    [199720790, [handlers_1.bytes]],
    // log(int256)
    [760966329, [handlers_1.int256]],
    // log(int)
    [1309416733, [handlers_1.int256]],
    // log(bytes1)
    [1847107880, [(0, handlers_1.fixedBytes)(1)]],
    // log(bytes2)
    [3921027734, [(0, handlers_1.fixedBytes)(2)]],
    // log(bytes3)
    [763578662, [(0, handlers_1.fixedBytes)(3)]],
    // log(bytes4)
    [3764340945, [(0, handlers_1.fixedBytes)(4)]],
    // log(bytes5)
    [2793701517, [(0, handlers_1.fixedBytes)(5)]],
    // log(bytes6)
    [2927928721, [(0, handlers_1.fixedBytes)(6)]],
    // log(bytes7)
    [1322614312, [(0, handlers_1.fixedBytes)(7)]],
    // log(bytes8)
    [1334060334, [(0, handlers_1.fixedBytes)(8)]],
    // log(bytes9)
    [2428341456, [(0, handlers_1.fixedBytes)(9)]],
    // log(bytes10)
    [20780939, [(0, handlers_1.fixedBytes)(10)]],
    // log(bytes11)
    [67127854, [(0, handlers_1.fixedBytes)(11)]],
    // log(bytes12)
    [2258660029, [(0, handlers_1.fixedBytes)(12)]],
    // log(bytes13)
    [2488442420, [(0, handlers_1.fixedBytes)(13)]],
    // log(bytes14)
    [2456219775, [(0, handlers_1.fixedBytes)(14)]],
    // log(bytes15)
    [3667227872, [(0, handlers_1.fixedBytes)(15)]],
    // log(bytes16)
    [1717330180, [(0, handlers_1.fixedBytes)(16)]],
    // log(bytes17)
    [866084666, [(0, handlers_1.fixedBytes)(17)]],
    // log(bytes18)
    [3302112666, [(0, handlers_1.fixedBytes)(18)]],
    // log(bytes19)
    [1584093747, [(0, handlers_1.fixedBytes)(19)]],
    // log(bytes20)
    [1367925737, [(0, handlers_1.fixedBytes)(20)]],
    // log(bytes21)
    [3923391840, [(0, handlers_1.fixedBytes)(21)]],
    // log(bytes22)
    [3589990556, [(0, handlers_1.fixedBytes)(22)]],
    // log(bytes23)
    [2879508237, [(0, handlers_1.fixedBytes)(23)]],
    // log(bytes24)
    [4055063348, [(0, handlers_1.fixedBytes)(24)]],
    // log(bytes25)
    [193248344, [(0, handlers_1.fixedBytes)(25)]],
    // log(bytes26)
    [4172368369, [(0, handlers_1.fixedBytes)(26)]],
    // log(bytes27)
    [976705501, [(0, handlers_1.fixedBytes)(27)]],
    // log(bytes28)
    [3358255854, [(0, handlers_1.fixedBytes)(28)]],
    // log(bytes29)
    [1265222613, [(0, handlers_1.fixedBytes)(29)]],
    // log(bytes30)
    [3994207469, [(0, handlers_1.fixedBytes)(30)]],
    // log(bytes31)
    [3263516050, [(0, handlers_1.fixedBytes)(31)]],
    // log(bytes32)
    [666357637, [(0, handlers_1.fixedBytes)(32)]],
    // log(address,address)
    [3673216170, [handlers_1.address, handlers_1.address]],
    // log(address,bool)
    [1974863315, [handlers_1.address, handlers_1.bool]],
    // log(address,string)
    [1973388987, [handlers_1.address, handlers_1.string]],
    // log(address,uint256)
    [2198464680, [handlers_1.address, handlers_1.uint256]],
    // log(address,uint)
    [574869411, [handlers_1.address, handlers_1.uint256]],
    // log(bool,address)
    [2235320393, [handlers_1.bool, handlers_1.address]],
    // log(bool,bool)
    [705760899, [handlers_1.bool, handlers_1.bool]],
    // log(bool,string)
    [2414527781, [handlers_1.bool, handlers_1.string]],
    // log(bool,uint256)
    [965833939, [handlers_1.bool, handlers_1.uint256]],
    // log(bool,uint)
    [910912146, [handlers_1.bool, handlers_1.uint256]],
    // log(string,address)
    [832238387, [handlers_1.string, handlers_1.address]],
    // log(string,bool)
    [3283441205, [handlers_1.string, handlers_1.bool]],
    // log(string,string)
    [1264337527, [handlers_1.string, handlers_1.string]],
    // log(string,uint256)
    [3054400204, [handlers_1.string, handlers_1.uint256]],
    // log(string,uint)
    [2534451664, [handlers_1.string, handlers_1.uint256]],
    // log(uint256,address)
    [1764191366, [handlers_1.uint256, handlers_1.address]],
    // log(uint,address)
    [1491830284, [handlers_1.uint256, handlers_1.address]],
    // log(uint256,bool)
    [480083635, [handlers_1.uint256, handlers_1.bool]],
    // log(uint,bool)
    [510514412, [handlers_1.uint256, handlers_1.bool]],
    // log(uint256,string)
    [1681903839, [handlers_1.uint256, handlers_1.string]],
    // log(uint,string)
    [262402885, [handlers_1.uint256, handlers_1.string]],
    // log(uint256,uint256)
    [4133908826, [handlers_1.uint256, handlers_1.uint256]],
    // log(uint,uint)
    [1812949376, [handlers_1.uint256, handlers_1.uint256]],
    // log(address,address,address)
    [25986242, [handlers_1.address, handlers_1.address, handlers_1.address]],
    // log(address,address,bool)
    [4070990470, [handlers_1.address, handlers_1.address, handlers_1.bool]],
    // log(address,address,string)
    [7426238, [handlers_1.address, handlers_1.address, handlers_1.string]],
    // log(address,address,uint256)
    [402547077, [handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(address,address,uint)
    [1815506290, [handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(address,bool,address)
    [4044790253, [handlers_1.address, handlers_1.bool, handlers_1.address]],
    // log(address,bool,bool)
    [3951234194, [handlers_1.address, handlers_1.bool, handlers_1.bool]],
    // log(address,bool,string)
    [555898316, [handlers_1.address, handlers_1.bool, handlers_1.string]],
    // log(address,bool,uint256)
    [2622462459, [handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(address,bool,uint)
    [742821141, [handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(address,string,address)
    [4035396840, [handlers_1.address, handlers_1.string, handlers_1.address]],
    // log(address,string,bool)
    [3473018801, [handlers_1.address, handlers_1.string, handlers_1.bool]],
    // log(address,string,string)
    [4218888805, [handlers_1.address, handlers_1.string, handlers_1.string]],
    // log(address,string,uint256)
    [1742565361, [handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(address,string,uint)
    [484110986, [handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(address,uint256,address)
    [2076235848, [handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(address,uint,address)
    [2548867988, [handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(address,uint256,bool)
    [1736575400, [handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(address,uint,bool)
    [3846889796, [handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(address,uint256,string)
    [2717051050, [handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(address,uint,string)
    [3136907337, [handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(address,uint256,uint256)
    [3063663350, [handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(address,uint,uint)
    [2273710942, [handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,address,address)
    [3530962535, [handlers_1.bool, handlers_1.address, handlers_1.address]],
    // log(bool,address,bool)
    [415876934, [handlers_1.bool, handlers_1.address, handlers_1.bool]],
    // log(bool,address,string)
    [3734671984, [handlers_1.bool, handlers_1.address, handlers_1.string]],
    // log(bool,address,uint256)
    [1601936123, [handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(bool,address,uint)
    [3950005167, [handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(bool,bool,address)
    [276362893, [handlers_1.bool, handlers_1.bool, handlers_1.address]],
    // log(bool,bool,bool)
    [1349555864, [handlers_1.bool, handlers_1.bool, handlers_1.bool]],
    // log(bool,bool,string)
    [626391622, [handlers_1.bool, handlers_1.bool, handlers_1.string]],
    // log(bool,bool,uint256)
    [317855234, [handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(bool,bool,uint)
    [2954061243, [handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(bool,string,address)
    [2509355347, [handlers_1.bool, handlers_1.string, handlers_1.address]],
    // log(bool,string,bool)
    [3686056519, [handlers_1.bool, handlers_1.string, handlers_1.bool]],
    // log(bool,string,string)
    [2960557183, [handlers_1.bool, handlers_1.string, handlers_1.string]],
    // log(bool,string,uint256)
    [278130193, [handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(bool,string,uint)
    [3224906412, [handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(bool,uint256,address)
    [143587794, [handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(bool,uint,address)
    [3302110471, [handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(bool,uint256,bool)
    [3906927529, [handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(bool,uint,bool)
    [464374251, [handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(bool,uint256,string)
    [3288086896, [handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(bool,uint,string)
    [3359211184, [handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(bool,uint256,uint256)
    [923808615, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,uint,uint)
    [995886048, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(string,address,address)
    [4243355104, [handlers_1.string, handlers_1.address, handlers_1.address]],
    // log(string,address,bool)
    [3374145236, [handlers_1.string, handlers_1.address, handlers_1.bool]],
    // log(string,address,string)
    [3773410639, [handlers_1.string, handlers_1.address, handlers_1.string]],
    // log(string,address,uint256)
    [220641573, [handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(string,address,uint)
    [130552343, [handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(string,bool,address)
    [2469116728, [handlers_1.string, handlers_1.bool, handlers_1.address]],
    // log(string,bool,bool)
    [2232122070, [handlers_1.string, handlers_1.bool, handlers_1.bool]],
    // log(string,bool,string)
    [3801674877, [handlers_1.string, handlers_1.bool, handlers_1.string]],
    // log(string,bool,uint256)
    [3378075862, [handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(string,bool,uint)
    [689682896, [handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(string,string,address)
    [2515337621, [handlers_1.string, handlers_1.string, handlers_1.address]],
    // log(string,string,bool)
    [2967534005, [handlers_1.string, handlers_1.string, handlers_1.bool]],
    // log(string,string,string)
    [753761519, [handlers_1.string, handlers_1.string, handlers_1.string]],
    // log(string,string,uint256)
    [1478619041, [handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(string,string,uint)
    [4083337817, [handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(string,uint256,address)
    [478069832, [handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(string,uint,address)
    [3817119609, [handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(string,uint256,bool)
    [3396809649, [handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(string,uint,bool)
    [4043501061, [handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(string,uint256,string)
    [1500569737, [handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(string,uint,string)
    [2750793529, [handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(string,uint256,uint256)
    [3393701099, [handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(string,uint,uint)
    [2526862595, [handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(uint256,address,address)
    [3170737120, [handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(uint,address,address)
    [2104993307, [handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(uint256,address,bool)
    [2607726658, [handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(uint,address,bool)
    [2060456590, [handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(uint256,address,string)
    [1674265081, [handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(uint,address,string)
    [3464692859, [handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(uint256,address,uint256)
    [1520131797, [handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(uint,address,uint)
    [2286109610, [handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(uint256,bool,address)
    [889741179, [handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(uint,bool,address)
    [1112473535, [handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(uint256,bool,bool)
    [544310864, [handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(uint,bool,bool)
    [3587091680, [handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(uint256,bool,string)
    [2239189025, [handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(uint,bool,string)
    [2332955902, [handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(uint256,bool,uint256)
    [537493524, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(uint,bool,uint)
    [1515034914, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(uint256,string,address)
    [2063255897, [handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(uint,string,address)
    [529592906, [handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(uint256,string,bool)
    [1290643290, [handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(uint,string,bool)
    [1185403086, [handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(uint256,string,string)
    [2970968351, [handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(uint,string,string)
    [1062716053, [handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(uint256,string,uint256)
    [933920076, [handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(uint,string,uint)
    [1533929535, [handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(uint256,uint256,address)
    [1553380145, [handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(uint,uint,address)
    [3191032091, [handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(uint256,uint256,bool)
    [1197922930, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(uint,uint,bool)
    [1733758967, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(uint256,uint256,string)
    [1909476082, [handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(uint,uint,string)
    [2104037094, [handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(uint256,uint256,uint256)
    [3522001468, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(uint,uint,uint)
    [3884059252, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(address,address,address,address)
    [1717301556, [handlers_1.address, handlers_1.address, handlers_1.address, handlers_1.address]],
    // log(address,address,address,bool)
    [238520724, [handlers_1.address, handlers_1.address, handlers_1.address, handlers_1.bool]],
    // log(address,address,address,string)
    [4161329696, [handlers_1.address, handlers_1.address, handlers_1.address, handlers_1.string]],
    // log(address,address,address,uint256)
    [2485456247, [handlers_1.address, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(address,address,address,uint)
    [3982404743, [handlers_1.address, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(address,address,bool,address)
    [2669396846, [handlers_1.address, handlers_1.address, handlers_1.bool, handlers_1.address]],
    // log(address,address,bool,bool)
    [752096074, [handlers_1.address, handlers_1.address, handlers_1.bool, handlers_1.bool]],
    // log(address,address,bool,string)
    [2858762440, [handlers_1.address, handlers_1.address, handlers_1.bool, handlers_1.string]],
    // log(address,address,bool,uint256)
    [963766156, [handlers_1.address, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(address,address,bool,uint)
    [2513854225, [handlers_1.address, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(address,address,string,address)
    [2406706454, [handlers_1.address, handlers_1.address, handlers_1.string, handlers_1.address]],
    // log(address,address,string,bool)
    [1863997774, [handlers_1.address, handlers_1.address, handlers_1.string, handlers_1.bool]],
    // log(address,address,string,string)
    [566079269, [handlers_1.address, handlers_1.address, handlers_1.string, handlers_1.string]],
    // log(address,address,string,uint256)
    [4011651047, [handlers_1.address, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(address,address,string,uint)
    [69767936, [handlers_1.address, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(address,address,uint256,address)
    [2376523509, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(address,address,uint,address)
    [3603321462, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(address,address,uint256,bool)
    [2604815586, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(address,address,uint,bool)
    [3270936812, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(address,address,uint256,string)
    [4256496016, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(address,address,uint,string)
    [2647731885, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(address,address,uint256,uint256)
    [3193255041, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(address,address,uint,uint)
    [1425929188, [handlers_1.address, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(address,bool,address,address)
    [1711502813, [handlers_1.address, handlers_1.bool, handlers_1.address, handlers_1.address]],
    // log(address,bool,address,bool)
    [2801077007, [handlers_1.address, handlers_1.bool, handlers_1.address, handlers_1.bool]],
    // log(address,bool,address,string)
    [769095910, [handlers_1.address, handlers_1.bool, handlers_1.address, handlers_1.string]],
    // log(address,bool,address,uint256)
    [2807847390, [handlers_1.address, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(address,bool,address,uint)
    [3698398930, [handlers_1.address, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(address,bool,bool,address)
    [3476636805, [handlers_1.address, handlers_1.bool, handlers_1.bool, handlers_1.address]],
    // log(address,bool,bool,bool)
    [3401856121, [handlers_1.address, handlers_1.bool, handlers_1.bool, handlers_1.bool]],
    // log(address,bool,bool,string)
    [3754205928, [handlers_1.address, handlers_1.bool, handlers_1.bool, handlers_1.string]],
    // log(address,bool,bool,uint256)
    [2353946086, [handlers_1.address, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(address,bool,bool,uint)
    [3484780374, [handlers_1.address, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(address,bool,string,address)
    [436029782, [handlers_1.address, handlers_1.bool, handlers_1.string, handlers_1.address]],
    // log(address,bool,string,bool)
    [1353532957, [handlers_1.address, handlers_1.bool, handlers_1.string, handlers_1.bool]],
    // log(address,bool,string,string)
    [1197235251, [handlers_1.address, handlers_1.bool, handlers_1.string, handlers_1.string]],
    // log(address,bool,string,uint256)
    [2162598411, [handlers_1.address, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(address,bool,string,uint)
    [2652011374, [handlers_1.address, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(address,bool,uint256,address)
    [3438776481, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(address,bool,uint,address)
    [227337758, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(address,bool,uint256,bool)
    [3294903840, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(address,bool,uint,bool)
    [2244855215, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(address,bool,uint256,string)
    [178704301, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(address,bool,uint,string)
    [2606272204, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(address,bool,uint256,uint256)
    [946861556, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(address,bool,uint,uint)
    [3255869470, [handlers_1.address, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(address,string,address,address)
    [221706784, [handlers_1.address, handlers_1.string, handlers_1.address, handlers_1.address]],
    // log(address,string,address,bool)
    [233909110, [handlers_1.address, handlers_1.string, handlers_1.address, handlers_1.bool]],
    // log(address,string,address,string)
    [4158874181, [handlers_1.address, handlers_1.string, handlers_1.address, handlers_1.string]],
    // log(address,string,address,uint256)
    [1166009295, [handlers_1.address, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(address,string,address,uint)
    [2350461865, [handlers_1.address, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(address,string,bool,address)
    [542667202, [handlers_1.address, handlers_1.string, handlers_1.bool, handlers_1.address]],
    // log(address,string,bool,bool)
    [1595759775, [handlers_1.address, handlers_1.string, handlers_1.bool, handlers_1.bool]],
    // log(address,string,bool,string)
    [3154862590, [handlers_1.address, handlers_1.string, handlers_1.bool, handlers_1.string]],
    // log(address,string,bool,uint256)
    [1365129398, [handlers_1.address, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(address,string,bool,uint)
    [3877655068, [handlers_1.address, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(address,string,string,address)
    [2689478535, [handlers_1.address, handlers_1.string, handlers_1.string, handlers_1.address]],
    // log(address,string,string,bool)
    [900007711, [handlers_1.address, handlers_1.string, handlers_1.string, handlers_1.bool]],
    // log(address,string,string,string)
    [1560462603, [handlers_1.address, handlers_1.string, handlers_1.string, handlers_1.string]],
    // log(address,string,string,uint256)
    [362776871, [handlers_1.address, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(address,string,string,uint)
    [2706362425, [handlers_1.address, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(address,string,uint256,address)
    [1662531192, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(address,string,uint,address)
    [3755464715, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(address,string,uint256,bool)
    [251125840, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(address,string,uint,bool)
    [2116357467, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(address,string,uint256,string)
    [1149776040, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(address,string,uint,string)
    [1561552329, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(address,string,uint256,uint256)
    [499704248, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(address,string,uint,uint)
    [2764647008, [handlers_1.address, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(address,uint256,address,address)
    [1200430178, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(address,uint,address,address)
    [3961816175, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(address,uint256,address,bool)
    [2713504179, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(address,uint,address,bool)
    [4051804649, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(address,uint256,address,string)
    [497649386, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(address,uint,address,string)
    [1567749022, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(address,uint256,address,uint256)
    [269444366, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(address,uint,address,uint)
    [2782496616, [handlers_1.address, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(address,uint256,bool,address)
    [2736520652, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(address,uint,bool,address)
    [602229106, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(address,uint256,bool,bool)
    [1005970743, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(address,uint,bool,bool)
    [4272018778, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(address,uint256,bool,string)
    [3316483577, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(address,uint,bool,string)
    [2391690869, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(address,uint256,bool,uint256)
    [586594713, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(address,uint,bool,uint)
    [1770996626, [handlers_1.address, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(address,uint256,string,address)
    [1547898183, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(address,uint,string,address)
    [3698927108, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(address,uint256,string,bool)
    [3474460764, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(address,uint,string,bool)
    [2751614737, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(address,uint256,string,string)
    [2292761606, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(address,uint,string,string)
    [2119616147, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(address,uint256,string,uint256)
    [3204577425, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(address,uint,string,uint)
    [4111650715, [handlers_1.address, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(address,uint256,uint256,address)
    [551786573, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(address,uint,uint,address)
    [519451700, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(address,uint256,uint256,bool)
    [1727118439, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(address,uint,uint,bool)
    [3964381346, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(address,uint256,uint256,string)
    [1244184599, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(address,uint,uint,string)
    [2301889963, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(address,uint256,uint256,uint256)
    [888202806, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(address,uint,uint,uint)
    [1024368100, [handlers_1.address, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,address,address,address)
    [487903233, [handlers_1.bool, handlers_1.address, handlers_1.address, handlers_1.address]],
    // log(bool,address,address,bool)
    [1180699616, [handlers_1.bool, handlers_1.address, handlers_1.address, handlers_1.bool]],
    // log(bool,address,address,string)
    [3625099623, [handlers_1.bool, handlers_1.address, handlers_1.address, handlers_1.string]],
    // log(bool,address,address,uint256)
    [208064958, [handlers_1.bool, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(bool,address,address,uint)
    [1384430956, [handlers_1.bool, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(bool,address,bool,address)
    [474063670, [handlers_1.bool, handlers_1.address, handlers_1.bool, handlers_1.address]],
    // log(bool,address,bool,bool)
    [1788626827, [handlers_1.bool, handlers_1.address, handlers_1.bool, handlers_1.bool]],
    // log(bool,address,bool,string)
    [1248250676, [handlers_1.bool, handlers_1.address, handlers_1.bool, handlers_1.string]],
    // log(bool,address,bool,uint256)
    [126031106, [handlers_1.bool, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(bool,address,bool,uint)
    [1287000017, [handlers_1.bool, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(bool,address,string,address)
    [1870422078, [handlers_1.bool, handlers_1.address, handlers_1.string, handlers_1.address]],
    // log(bool,address,string,bool)
    [3804222987, [handlers_1.bool, handlers_1.address, handlers_1.string, handlers_1.bool]],
    // log(bool,address,string,string)
    [2805734838, [handlers_1.bool, handlers_1.address, handlers_1.string, handlers_1.string]],
    // log(bool,address,string,uint256)
    [3256837319, [handlers_1.bool, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(bool,address,string,uint)
    [194640930, [handlers_1.bool, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(bool,address,uint256,address)
    [325780957, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(bool,address,uint,address)
    [1760647349, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(bool,address,uint256,bool)
    [3590430492, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(bool,address,uint,bool)
    [4002252402, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(bool,address,uint256,string)
    [1374724088, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(bool,address,uint,string)
    [2691192883, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(bool,address,uint256,uint256)
    [2079424929, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,address,uint,uint)
    [2617143996, [handlers_1.bool, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,bool,address,address)
    [4102557348, [handlers_1.bool, handlers_1.bool, handlers_1.address, handlers_1.address]],
    // log(bool,bool,address,bool)
    [3231908568, [handlers_1.bool, handlers_1.bool, handlers_1.address, handlers_1.bool]],
    // log(bool,bool,address,string)
    [2695133539, [handlers_1.bool, handlers_1.bool, handlers_1.address, handlers_1.string]],
    // log(bool,bool,address,uint256)
    [1276263767, [handlers_1.bool, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(bool,bool,address,uint)
    [1620281063, [handlers_1.bool, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(bool,bool,bool,address)
    [2352126746, [handlers_1.bool, handlers_1.bool, handlers_1.bool, handlers_1.address]],
    // log(bool,bool,bool,bool)
    [992632032, [handlers_1.bool, handlers_1.bool, handlers_1.bool, handlers_1.bool]],
    // log(bool,bool,bool,string)
    [719587540, [handlers_1.bool, handlers_1.bool, handlers_1.bool, handlers_1.string]],
    // log(bool,bool,bool,uint256)
    [1836074433, [handlers_1.bool, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(bool,bool,bool,uint)
    [3259532109, [handlers_1.bool, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(bool,bool,string,address)
    [4188875657, [handlers_1.bool, handlers_1.bool, handlers_1.string, handlers_1.address]],
    // log(bool,bool,string,bool)
    [3092715066, [handlers_1.bool, handlers_1.bool, handlers_1.string, handlers_1.bool]],
    // log(bool,bool,string,string)
    [1830717265, [handlers_1.bool, handlers_1.bool, handlers_1.string, handlers_1.string]],
    // log(bool,bool,string,uint256)
    [3819555375, [handlers_1.bool, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(bool,bool,string,uint)
    [395003525, [handlers_1.bool, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(bool,bool,uint256,address)
    [1420274080, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(bool,bool,uint,address)
    [201299213, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(bool,bool,uint256,bool)
    [1637764366, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(bool,bool,uint,bool)
    [2874982852, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(bool,bool,uint256,string)
    [2111099104, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(bool,bool,uint,string)
    [1348569399, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(bool,bool,uint256,uint256)
    [196087467, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,bool,uint,uint)
    [1181212302, [handlers_1.bool, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,string,address,address)
    [724244700, [handlers_1.bool, handlers_1.string, handlers_1.address, handlers_1.address]],
    // log(bool,string,address,bool)
    [1842623690, [handlers_1.bool, handlers_1.string, handlers_1.address, handlers_1.bool]],
    // log(bool,string,address,string)
    [316065672, [handlers_1.bool, handlers_1.string, handlers_1.address, handlers_1.string]],
    // log(bool,string,address,uint256)
    [2781534868, [handlers_1.bool, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(bool,string,address,uint)
    [453743963, [handlers_1.bool, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(bool,string,bool,address)
    [1401816747, [handlers_1.bool, handlers_1.string, handlers_1.bool, handlers_1.address]],
    // log(bool,string,bool,bool)
    [3697185627, [handlers_1.bool, handlers_1.string, handlers_1.bool, handlers_1.bool]],
    // log(bool,string,bool,string)
    [1211958294, [handlers_1.bool, handlers_1.string, handlers_1.bool, handlers_1.string]],
    // log(bool,string,bool,uint256)
    [369533843, [handlers_1.bool, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(bool,string,bool,uint)
    [2372902053, [handlers_1.bool, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(bool,string,string,address)
    [2547225816, [handlers_1.bool, handlers_1.string, handlers_1.string, handlers_1.address]],
    // log(bool,string,string,bool)
    [508266469, [handlers_1.bool, handlers_1.string, handlers_1.string, handlers_1.bool]],
    // log(bool,string,string,string)
    [392356650, [handlers_1.bool, handlers_1.string, handlers_1.string, handlers_1.string]],
    // log(bool,string,string,uint256)
    [2078327787, [handlers_1.bool, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(bool,string,string,uint)
    [1574643090, [handlers_1.bool, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(bool,string,uint256,address)
    [362193358, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(bool,string,uint,address)
    [1529002296, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(bool,string,uint256,bool)
    [1796103507, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(bool,string,uint,bool)
    [549177775, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(bool,string,uint256,string)
    [450457062, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(bool,string,uint,string)
    [2007084013, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(bool,string,uint256,uint256)
    [679886795, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,string,uint,uint)
    [2387273838, [handlers_1.bool, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,uint256,address,address)
    [653615272, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(bool,uint,address,address)
    [2318373034, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(bool,uint256,address,bool)
    [3032683775, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(bool,uint,address,bool)
    [1705899016, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(bool,uint256,address,string)
    [464760986, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(bool,uint,address,string)
    [403247937, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(bool,uint256,address,uint256)
    [355982471, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(bool,uint,address,uint)
    [3399820138, [handlers_1.bool, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(bool,uint256,bool,address)
    [2597139990, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(bool,uint,bool,address)
    [1114097656, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(bool,uint256,bool,bool)
    [3468031191, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(bool,uint,bool,bool)
    [2650928961, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(bool,uint256,bool,string)
    [2437143473, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(bool,uint,bool,string)
    [3067439572, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(bool,uint256,bool,uint256)
    [2140912802, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(bool,uint,bool,uint)
    [3554563475, [handlers_1.bool, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(bool,uint256,string,address)
    [4275904511, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(bool,uint,string,address)
    [2781285673, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(bool,uint256,string,bool)
    [3857124139, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(bool,uint,string,bool)
    [2446522387, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(bool,uint256,string,string)
    [4122747465, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(bool,uint,string,string)
    [3542771016, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(bool,uint256,string,uint256)
    [1779538402, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(bool,uint,string,uint)
    [1098907931, [handlers_1.bool, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(bool,uint256,uint256,address)
    [14518201, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(bool,uint,uint,address)
    [4049711649, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(bool,uint256,uint256,bool)
    [3197649747, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(bool,uint,uint,bool)
    [2753397214, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(bool,uint256,uint256,string)
    [2389310301, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(bool,uint,uint,string)
    [3657852616, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(bool,uint256,uint256,uint256)
    [927708338, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(bool,uint,uint,uint)
    [853517604, [handlers_1.bool, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(string,address,address,address)
    [3985582326, [handlers_1.string, handlers_1.address, handlers_1.address, handlers_1.address]],
    // log(string,address,address,bool)
    [3047013728, [handlers_1.string, handlers_1.address, handlers_1.address, handlers_1.bool]],
    // log(string,address,address,string)
    [2148146279, [handlers_1.string, handlers_1.address, handlers_1.address, handlers_1.string]],
    // log(string,address,address,uint256)
    [2398352281, [handlers_1.string, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(string,address,address,uint)
    [1857524797, [handlers_1.string, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(string,address,bool,address)
    [573965245, [handlers_1.string, handlers_1.address, handlers_1.bool, handlers_1.address]],
    // log(string,address,bool,bool)
    [2038975531, [handlers_1.string, handlers_1.address, handlers_1.bool, handlers_1.bool]],
    // log(string,address,bool,string)
    [72663161, [handlers_1.string, handlers_1.address, handlers_1.bool, handlers_1.string]],
    // log(string,address,bool,uint256)
    [1050642026, [handlers_1.string, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(string,address,bool,uint)
    [3318856587, [handlers_1.string, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(string,address,string,address)
    [2864486961, [handlers_1.string, handlers_1.address, handlers_1.string, handlers_1.address]],
    // log(string,address,string,bool)
    [1595265676, [handlers_1.string, handlers_1.address, handlers_1.string, handlers_1.bool]],
    // log(string,address,string,string)
    [609847026, [handlers_1.string, handlers_1.address, handlers_1.string, handlers_1.string]],
    // log(string,address,string,uint256)
    [2446397742, [handlers_1.string, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(string,address,string,uint)
    [2405583849, [handlers_1.string, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(string,address,uint256,address)
    [1677429701, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(string,address,uint,address)
    [2741431424, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(string,address,uint256,bool)
    [4232594928, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(string,address,uint,bool)
    [1522647356, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(string,address,uint256,string)
    [1514632754, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(string,address,uint,string)
    [1280700980, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(string,address,uint256,uint256)
    [4176812830, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(string,address,uint,uint)
    [3668153533, [handlers_1.string, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(string,bool,address,address)
    [870964509, [handlers_1.string, handlers_1.bool, handlers_1.address, handlers_1.address]],
    // log(string,bool,address,bool)
    [2508990662, [handlers_1.string, handlers_1.bool, handlers_1.address, handlers_1.bool]],
    // log(string,bool,address,string)
    [764294052, [handlers_1.string, handlers_1.bool, handlers_1.address, handlers_1.string]],
    // log(string,bool,address,uint256)
    [1560853253, [handlers_1.string, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(string,bool,address,uint)
    [685723286, [handlers_1.string, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(string,bool,bool,address)
    [1905304873, [handlers_1.string, handlers_1.bool, handlers_1.bool, handlers_1.address]],
    // log(string,bool,bool,bool)
    [2304440517, [handlers_1.string, handlers_1.bool, handlers_1.bool, handlers_1.bool]],
    // log(string,bool,bool,string)
    [2636305885, [handlers_1.string, handlers_1.bool, handlers_1.bool, handlers_1.string]],
    // log(string,bool,bool,uint256)
    [2386524329, [handlers_1.string, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(string,bool,bool,uint)
    [2155164136, [handlers_1.string, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(string,bool,string,address)
    [3764542249, [handlers_1.string, handlers_1.bool, handlers_1.string, handlers_1.address]],
    // log(string,bool,string,bool)
    [1066037277, [handlers_1.string, handlers_1.bool, handlers_1.string, handlers_1.bool]],
    // log(string,bool,string,string)
    [2821114603, [handlers_1.string, handlers_1.bool, handlers_1.string, handlers_1.string]],
    // log(string,bool,string,uint256)
    [620303461, [handlers_1.string, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(string,bool,string,uint)
    [885731469, [handlers_1.string, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(string,bool,uint256,address)
    [2472413631, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(string,bool,uint,address)
    [1909687565, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(string,bool,uint256,bool)
    [2331496330, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(string,bool,uint,bool)
    [1019590099, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(string,bool,uint256,string)
    [1949134567, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(string,bool,uint,string)
    [1119461927, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(string,bool,uint256,uint256)
    [1689631591, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(string,bool,uint,uint)
    [1572859960, [handlers_1.string, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(string,string,address,address)
    [1134328815, [handlers_1.string, handlers_1.string, handlers_1.address, handlers_1.address]],
    // log(string,string,address,bool)
    [1556958775, [handlers_1.string, handlers_1.string, handlers_1.address, handlers_1.bool]],
    // log(string,string,address,string)
    [3944480640, [handlers_1.string, handlers_1.string, handlers_1.address, handlers_1.string]],
    // log(string,string,address,uint256)
    [2093204999, [handlers_1.string, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(string,string,address,uint)
    [1250010474, [handlers_1.string, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(string,string,bool,address)
    [3279013851, [handlers_1.string, handlers_1.string, handlers_1.bool, handlers_1.address]],
    // log(string,string,bool,bool)
    [1081628777, [handlers_1.string, handlers_1.string, handlers_1.bool, handlers_1.bool]],
    // log(string,string,bool,string)
    [1585754346, [handlers_1.string, handlers_1.string, handlers_1.bool, handlers_1.string]],
    // log(string,string,bool,uint256)
    [3601791698, [handlers_1.string, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(string,string,bool,uint)
    [2256636538, [handlers_1.string, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(string,string,string,address)
    [1834430276, [handlers_1.string, handlers_1.string, handlers_1.string, handlers_1.address]],
    // log(string,string,string,bool)
    [739726573, [handlers_1.string, handlers_1.string, handlers_1.string, handlers_1.bool]],
    // log(string,string,string,string)
    [3731419658, [handlers_1.string, handlers_1.string, handlers_1.string, handlers_1.string]],
    // log(string,string,string,uint256)
    [2393878571, [handlers_1.string, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(string,string,string,uint)
    [2681211381, [handlers_1.string, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(string,string,uint256,address)
    [270792626, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(string,string,uint,address)
    [1565476480, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(string,string,uint256,bool)
    [3282609748, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(string,string,uint,bool)
    [3864418506, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(string,string,uint256,string)
    [1562023706, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(string,string,uint,string)
    [2366909661, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(string,string,uint256,uint256)
    [4099767596, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(string,string,uint,uint)
    [3587119056, [handlers_1.string, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(string,uint256,address,address)
    [1587722158, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(string,uint,address,address)
    [3939013249, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(string,uint256,address,bool)
    [2182163010, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(string,uint,address,bool)
    [285649143, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(string,uint256,address,string)
    [2684039059, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(string,uint,address,string)
    [844415720, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(string,uint256,address,uint256)
    [1325727174, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(string,uint,address,uint)
    [1481210622, [handlers_1.string, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(string,uint256,bool,address)
    [3773389720, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(string,uint,bool,address)
    [3847527825, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(string,uint256,bool,bool)
    [894187222, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(string,uint,bool,bool)
    [3816813520, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(string,uint256,bool,string)
    [2885106328, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(string,uint,bool,string)
    [1993105508, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(string,uint256,bool,uint256)
    [3827003247, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(string,uint,bool,uint)
    [1427009269, [handlers_1.string, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(string,uint256,string,address)
    [2084975268, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(string,uint,string,address)
    [3144824297, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(string,uint256,string,bool)
    [2099530013, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(string,uint,string,bool)
    [3919545039, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(string,uint256,string,string)
    [1522028063, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(string,uint,string,string)
    [1821956834, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(string,uint256,string,uint256)
    [3330189777, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(string,uint,string,uint)
    [2697245221, [handlers_1.string, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(string,uint256,uint256,address)
    [3793609336, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(string,uint,uint,address)
    [3201771711, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(string,uint256,uint256,bool)
    [1982258066, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(string,uint,uint,bool)
    [4147936829, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(string,uint256,uint256,string)
    [2236298390, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(string,uint,uint,string)
    [2773406909, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(string,uint256,uint256,uint256)
    [2812835923, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(string,uint,uint,uint)
    [149837414, [handlers_1.string, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(uint256,address,address,address)
    [612938772, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.address]],
    // log(uint,address,address,address)
    [1430734329, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.address]],
    // log(uint256,address,address,bool)
    [153090805, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.bool]],
    // log(uint,address,address,bool)
    [22350596, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.bool]],
    // log(uint256,address,address,string)
    [52195187, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.string]],
    // log(uint,address,address,string)
    [2034490470, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.string]],
    // log(uint256,address,address,uint256)
    [1936653238, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(uint,address,address,uint)
    [2587672470, [handlers_1.uint256, handlers_1.address, handlers_1.address, handlers_1.uint256]],
    // log(uint256,address,bool,address)
    [4017276179, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.address]],
    // log(uint,address,bool,address)
    [3056677012, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.address]],
    // log(uint256,address,bool,bool)
    [3813741583, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.bool]],
    // log(uint,address,bool,bool)
    [2116501773, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.bool]],
    // log(uint256,address,bool,string)
    [2432370346, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.string]],
    // log(uint,address,bool,string)
    [1676730946, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.string]],
    // log(uint256,address,bool,uint256)
    [1522374954, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(uint,address,bool,uint)
    [2064181483, [handlers_1.uint256, handlers_1.address, handlers_1.bool, handlers_1.uint256]],
    // log(uint256,address,string,address)
    [2629472255, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.address]],
    // log(uint,address,string,address)
    [3420819197, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.address]],
    // log(uint256,address,string,bool)
    [3425872647, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.bool]],
    // log(uint,address,string,bool)
    [581204390, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.bool]],
    // log(uint256,address,string,string)
    [1041403043, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.string]],
    // log(uint,address,string,string)
    [2373420580, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.string]],
    // log(uint256,address,string,uint256)
    [1182952285, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(uint,address,string,uint)
    [2697204968, [handlers_1.uint256, handlers_1.address, handlers_1.string, handlers_1.uint256]],
    // log(uint256,address,uint256,address)
    [364980149, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(uint,address,uint,address)
    [4256361684, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.address]],
    // log(uint256,address,uint256,bool)
    [1601452668, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(uint,address,uint,bool)
    [435581801, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.bool]],
    // log(uint256,address,uint256,string)
    [3719324961, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(uint,address,uint,string)
    [1054063912, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.string]],
    // log(uint256,address,uint256,uint256)
    [211605953, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(uint,address,uint,uint)
    [3399106228, [handlers_1.uint256, handlers_1.address, handlers_1.uint256, handlers_1.uint256]],
    // log(uint256,bool,address,address)
    [2716814523, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.address]],
    // log(uint,bool,address,address)
    [2263728396, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.address]],
    // log(uint256,bool,address,bool)
    [1162695845, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.bool]],
    // log(uint,bool,address,bool)
    [2449150530, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.bool]],
    // log(uint256,bool,address,string)
    [2917159623, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.string]],
    // log(uint,bool,address,string)
    [2721084958, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.string]],
    // log(uint256,bool,address,uint256)
    [125994997, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(uint,bool,address,uint)
    [1102442299, [handlers_1.uint256, handlers_1.bool, handlers_1.address, handlers_1.uint256]],
    // log(uint256,bool,bool,address)
    [1768164185, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.address]],
    // log(uint,bool,bool,address)
    [1392910941, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.address]],
    // log(uint256,bool,bool,bool)
    [3069540257, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.bool]],
    // log(uint,bool,bool,bool)
    [1315722005, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.bool]],
    // log(uint256,bool,bool,string)
    [3722155361, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.string]],
    // log(uint,bool,bool,string)
    [831186331, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.string]],
    // log(uint256,bool,bool,uint256)
    [1952763427, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(uint,bool,bool,uint)
    [3173363033, [handlers_1.uint256, handlers_1.bool, handlers_1.bool, handlers_1.uint256]],
    // log(uint256,bool,string,address)
    [4015165464, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.address]],
    // log(uint,bool,string,address)
    [1231956916, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.address]],
    // log(uint256,bool,string,bool)
    [3952250239, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.bool]],
    // log(uint,bool,string,bool)
    [879671495, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.bool]],
    // log(uint256,bool,string,string)
    [1757984957, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.string]],
    // log(uint,bool,string,string)
    [2754870525, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.string]],
    // log(uint256,bool,string,uint256)
    [740099910, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(uint,bool,string,uint)
    [2438978344, [handlers_1.uint256, handlers_1.bool, handlers_1.string, handlers_1.uint256]],
    // log(uint256,bool,uint256,address)
    [2295029825, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(uint,bool,uint,address)
    [1329595790, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.address]],
    // log(uint256,bool,uint256,bool)
    [2443193898, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(uint,bool,uint,bool)
    [3534472445, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.bool]],
    // log(uint256,bool,uint256,string)
    [3724797812, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(uint,bool,uint,string)
    [3906845782, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.string]],
    // log(uint256,bool,uint256,uint256)
    [3333212072, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(uint,bool,uint,uint)
    [1451396516, [handlers_1.uint256, handlers_1.bool, handlers_1.uint256, handlers_1.uint256]],
    // log(uint256,string,address,address)
    [1634266465, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.address]],
    // log(uint,string,address,address)
    [2141537675, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.address]],
    // log(uint256,string,address,bool)
    [2428701270, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.bool]],
    // log(uint,string,address,bool)
    [4181720887, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.bool]],
    // log(uint256,string,address,string)
    [2621104033, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.string]],
    // log(uint,string,address,string)
    [4170733439, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.string]],
    // log(uint256,string,address,uint256)
    [3906142605, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(uint,string,address,uint)
    [2565338099, [handlers_1.uint256, handlers_1.string, handlers_1.address, handlers_1.uint256]],
    // log(uint256,string,bool,address)
    [2922300801, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.address]],
    // log(uint,string,bool,address)
    [2037328032, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.address]],
    // log(uint256,string,bool,bool)
    [3126025628, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.bool]],
    // log(uint,string,bool,bool)
    [1371286465, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.bool]],
    // log(uint256,string,bool,string)
    [3537118157, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.string]],
    // log(uint,string,bool,string)
    [2370346144, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.string]],
    // log(uint256,string,bool,uint256)
    [3472922752, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(uint,string,bool,uint)
    [2763295359, [handlers_1.uint256, handlers_1.string, handlers_1.bool, handlers_1.uint256]],
    // log(uint256,string,string,address)
    [3582182914, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.address]],
    // log(uint,string,string,address)
    [3432549024, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.address]],
    // log(uint256,string,string,bool)
    [3014047421, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.bool]],
    // log(uint,string,string,bool)
    [310782872, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.bool]],
    // log(uint256,string,string,string)
    [564987523, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.string]],
    // log(uint,string,string,string)
    [1474103825, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.string]],
    // log(uint256,string,string,uint256)
    [2955463101, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(uint,string,string,uint)
    [1995203422, [handlers_1.uint256, handlers_1.string, handlers_1.string, handlers_1.uint256]],
    // log(uint256,string,uint256,address)
    [992115124, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(uint,string,uint,address)
    [2877020669, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.address]],
    // log(uint256,string,uint256,bool)
    [1763348340, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(uint,string,uint,bool)
    [2270850606, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.bool]],
    // log(uint256,string,uint256,string)
    [3082360010, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(uint,string,uint,string)
    [2730232985, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.string]],
    // log(uint256,string,uint256,uint256)
    [2193775476, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(uint,string,uint,uint)
    [3221501959, [handlers_1.uint256, handlers_1.string, handlers_1.uint256, handlers_1.uint256]],
    // log(uint256,uint256,address,address)
    [1453707697, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(uint,uint,address,address)
    [3398671136, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.address]],
    // log(uint256,uint256,address,bool)
    [365610102, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(uint,uint,address,bool)
    [2833785006, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.bool]],
    // log(uint256,uint256,address,string)
    [1826504888, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(uint,uint,address,string)
    [3600994782, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.string]],
    // log(uint256,uint256,address,uint256)
    [2297881778, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(uint,uint,address,uint)
    [1628154048, [handlers_1.uint256, handlers_1.uint256, handlers_1.address, handlers_1.uint256]],
    // log(uint256,uint256,bool,address)
    [2592172675, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(uint,uint,bool,address)
    [3776410703, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.address]],
    // log(uint256,uint256,bool,bool)
    [2869451494, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(uint,uint,bool,bool)
    [2495495089, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.bool]],
    // log(uint256,uint256,bool,string)
    [2780101785, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(uint,uint,bool,string)
    [4024028142, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.string]],
    // log(uint256,uint256,bool,uint256)
    [3950997458, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(uint,uint,bool,uint)
    [1818524812, [handlers_1.uint256, handlers_1.uint256, handlers_1.bool, handlers_1.uint256]],
    // log(uint256,uint256,string,address)
    [1121066423, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(uint,uint,string,address)
    [1127384482, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.address]],
    // log(uint256,uint256,string,bool)
    [2062986021, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(uint,uint,string,bool)
    [2989403910, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.bool]],
    // log(uint256,uint256,string,string)
    [668512210, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(uint,uint,string,string)
    [2080582194, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.string]],
    // log(uint256,uint256,string,uint256)
    [1570936811, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(uint,uint,string,uint)
    [949229117, [handlers_1.uint256, handlers_1.uint256, handlers_1.string, handlers_1.uint256]],
    // log(uint256,uint256,uint256,address)
    [4202792367, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(uint,uint,uint,address)
    [3766828905, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.address]],
    // log(uint256,uint256,uint256,bool)
    [3315126661, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(uint,uint,uint,bool)
    [1683143115, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.bool]],
    // log(uint256,uint256,uint256,string)
    [1506790371, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(uint,uint,uint,string)
    [2024634892, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.string]],
    // log(uint256,uint256,uint256,uint256)
    [423606272, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]],
    // log(uint,uint,uint,uint)
    [1554033982, [handlers_1.uint256, handlers_1.uint256, handlers_1.uint256, handlers_1.uint256]]
]);
//# sourceMappingURL=signatures.js.map